export default "__VITE_ASSET__GJ1ES7Yw__";